import request from '@utils/request';

export const fetcher = (...args) => request.get(...args).then(res => res.data);
